import { mapEnumToOptions } from '@abp/ng.core';

export enum QuestionState {
  Inactive = 0,
  Active = 1,
}

export const questionStateOptions = mapEnumToOptions(QuestionState);
